import { ReactNode } from 'react';
import cn from 'classnames';
import Popover, { PopoverPlacement, IPopoverProps } from '@creditflowresearch/uilib/Popover';
import PopoverContent from './PopoverContent';

import styles from './loginOrSignUpPopover.module.scss';

interface ILoginOrSignUpPopoverProps {
  children: ReactNode,
  isRestricted: boolean,
  placement?: PopoverPlacement,
  offsetOptions?: IPopoverProps['offsetOptions'],
  className?: string,
  isBlockLevelTrigger?: boolean,
  dataTest?: string,
}
const LoginOrSignUpPopover = ({
  children,
  isRestricted,
  placement = 'top',
  offsetOptions,
  className,
  isBlockLevelTrigger = false,
  dataTest = 'loginOrSignUpPopover',
}: ILoginOrSignUpPopoverProps) => {
  if (!isRestricted) {
    return <>{ children }</>;
  }

  return (
    <Popover
      content={ <PopoverContent /> }
      triggerEvent="hover"
      placement={ placement }
      renderOnlyVisible
      dataTest={ dataTest }
      className={ cn(styles.popover, className) }
      referenceClassName={ isBlockLevelTrigger ? styles.blockLevelReference : undefined }
      contentClassName={ styles.popoverContainer }
      arrowClassName={ styles.popoverArrow }
      offsetOptions={ offsetOptions }
    >
      { children }
    </Popover>
  );
};

export default LoginOrSignUpPopover;
